import { ReactComponent as Level1 } from "../svg/level1.svg";
import { ReactComponent as Level2 } from "../svg/level2.svg";
import { ReactComponent as Level3 } from "../svg/level3.svg";
import { ReactComponent as Level4 } from "../svg/level4.svg";
import { ReactComponent as Level5 } from "../svg/level5.svg";

export const levelIcons = {
  1: Level1,
  2: Level2,
  3: Level3,
  4: Level4,
  5: Level5,
}